import React, { useState, useEffect } from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Button as ButtonBase } from 'js/social/shared/design_system/Button';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Colors } from 'js/design_system/Color';
import CloseIcon from 'js/design_system/icons/close.svg';
import { currentUser } from 'js/utils/user';
import { recordShow, recordDismissal } from 'js/utils/dismissibles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Body)`
  color: $ds-black;
`;

const CloseButton = styled(ButtonBase)`
  height: 24px !important;
  margin: 0;
  width: auto !important;
  padding: 3px 0 0 !important;
`;

type Props = {
  className?: string;
  affiliation: {
    department: {
      university: {
        id: number;
        name: string;
      };
    };
  };
};

export const AffiliationPrompt: React.FC<Props> = ({
  className,
  affiliation,
}) => {
  const universityName = affiliation.department.university.name;
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    recordShow('HomeAffiliationPrompt');
  }, []);

  if (dismissed || !universityName) {
    return null;
  }

  return (
    <Container className={className}>
      <Header>
        <Title>Are you at {universityName}?</Title>
        <CloseButton
          aria-label="Close"
          onClick={() => {
            recordDismissal('HomeAffiliationPrompt');
            setDismissed(true);
          }}
          variant="text-gray"
        >
          <CloseIcon color={Colors.GrayDark} />
        </CloseButton>
      </Header>
      <ButtonLink
        href={`${currentUser?.url}?update_affiliations=true`}
        secondary
        fullWidth
      >
        Edit affiliation
      </ButtonLink>
    </Container>
  );
};
